import { render, staticRenderFns } from "./HuntingWordsCreate.vue?vue&type=template&id=2ba4a62e&"
import script from "./HuntingWordsCreate.vue?vue&type=script&lang=js&"
export * from "./HuntingWordsCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports